import { render, staticRenderFns } from "./ParcelDetails.vue?vue&type=template&id=6a1ea4d8&"
import script from "./ParcelDetails.vue?vue&type=script&lang=js&"
export * from "./ParcelDetails.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports